import { NO_NAMES_HINT } from "../respond/RespondAssessment";

// PRIVACY_GATE_REGISTER_19_1 280926 V1.1, "G-P5 for staff": the respondent's
// no-names hint (PRIVACY_DOCUMENTATION_FIRST_CLIENT 240926 V1.1 §8), shown
// under every free-text field LINNFOSS staff type into and the platform
// stores — rationale, observations, evidence, findings, actions and their
// reasons. Same words, same look; the text lives on the respondent side so
// the two can never drift apart.
//
// A block-level span rather than a <p>: some fields sit inside inline rows,
// where a <p> is not valid, and `flexBasis: 100%` puts the hint on its own
// line under the field when that row is a wrapping flex container.
export function NoNamesHint() {
  return (
    <span style={{ display: "block", flexBasis: "100%", fontSize: "var(--lf-meta-size)", color: "var(--text-muted)", margin: "0.2rem 0" }}>
      {NO_NAMES_HINT}
    </span>
  );
}
